import { SearchTerm } from "./SearchTerm";

const HardwareReportSearch: SearchTerm[] = [
    {
        heading: "Name",
        accessor: "name",
        searchOnName: "devName",
        translationKey: "name"
    },
    {
        heading: "Address",
        accessor: "address",
        searchOnName: "address",
        translationKey: "address"
    },
    {
        heading: "Device Description",
        accessor: "deviceDescription",
        searchOnName: "devDesc",
        translationKey: "deviceDescription"
    },
    {
        heading: "Type",
        accessor: "type",
        searchOnName: "type",
        translationKey: "type"
    },
    {
        heading: "Door",
        accessor: "locName",
        searchOnName: "location.locName",
        translationKey: "door"
    },
    {
        heading: "Door Description",
        accessor: "locDescription",
        searchOnName: "location.locDesc",
        translationKey: "doorDescription"
    },
    {
        heading: "Zone",
        accessor: "zoneName",
        searchOnName: "zone.zoneName",
        translationKey: "zone"
    },
    {
        heading: "Building",
        accessor: "buildingName",
        searchOnName: "building.buildingName",
        translationKey: "building"
    },
    {
        heading: "Floor",
        accessor: "floorName",
        searchOnName: "floor.floorName",
        translationKey: "floor"
    },
    {
        heading: "Site",
        accessor: "siteName",
        searchOnName: "site.siteName",
        translationKey: "site"
    },
];

export default HardwareReportSearch;